import { render } from "./LanguageNav.vue?vue&type=template&id=4c09f6cc"
import script from "./LanguageNav.vue?vue&type=script&lang=js"
export * from "./LanguageNav.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__